"use client";

import { CircleNotchIcon } from "@phosphor-icons/react/dist/csr/CircleNotch";
import { cva, type VariantProps } from "class-variance-authority";
import type { ReactNode } from "react";

import { cn } from "../lib/utils";

const spinnerVariants = cva("flex-col items-center justify-center", {
  defaultVariants: {
    show: true,
  },
  variants: {
    show: {
      false: "hidden",
      true: "flex",
    },
  },
});

const loaderVariants = cva("animate-spin text-primary", {
  defaultVariants: {
    size: "medium",
  },
  variants: {
    size: {
      "inside-button": "size-4",
      large: "size-12",
      medium: "size-8",
      small: "size-6",
    },
  },
});

interface SpinnerProps extends VariantProps<typeof spinnerVariants>, VariantProps<typeof loaderVariants> {
  children?: ReactNode;
  /** Applied to the icon, not the wrapper. Size the glyph here; the wrapper is not styleable. */
  className?: string;
}

function Spinner({ children, className, show, size }: SpinnerProps) {
  return (
    <span className={spinnerVariants({ show })} data-slot="spinner">
      <CircleNotchIcon className={cn(loaderVariants({ size }), className)} />
      {children}
    </span>
  );
}

export { Spinner, type SpinnerProps };
